import BASEURLGESTTOR from '../api/gesttor'
import { cadastrarContratoPayload, paramsListarContrato } from '../../interfaces/contratos'


export function cadastrarContrato (payload: cadastrarContratoPayload) {
    return BASEURLGESTTOR.post('/contratos', payload)
}

export function listarContratos (params: paramsListarContrato) {
    return BASEURLGESTTOR.get(`/contratos?situacao=${params.situacao}&termo=${params.termo}`)
}

export function dadosContratos (idContrato: string) {
    return BASEURLGESTTOR.get(`/contratos/dados/${idContrato}`)
}


